import { IndeterminateCheckbox } from './IndeterminateCheckbox';
import React from 'react';
import styled from '@emotion/styled';
import { useSelection } from '../../features/items/state/selection.state';

const CheckboxWrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   transform: translateY(5px) translateX(4px);
`;

export const HeaderCheckbox = () => {
   const { isAllSelected, isAnySelected, selectAll } = useSelection();
   return (
      <CheckboxWrapper>
         <IndeterminateCheckbox
            {...{
               checked: isAllSelected,
               indeterminate: isAnySelected,
               onChange: () => selectAll(),
            }}
         />
      </CheckboxWrapper>
   );
};
